<template>
    <v-touch tag="div" class="answers answersslideshow" v-on:swipeleft="(current < answers.length - 1) ? current++ : current = current" v-on:swiperight="(current > 0) ? current-- : current = current">
        <transition-group id="answer-cards" class="answer-cards" name="staggered-fade" tag="ul" :css="false" @enter="enter" @leave="leave" mode="in-out">
            <li v-for="(answer, index) in answers" :key="index" class="answer-card" :class="{'correct': answer.points}" v-if="current === index">
                <div class='ac-question'>{{ answer.question }}</div>
                <div class='answer'>Jij zei: <span>{{ answer.answer }}</span><span class="points">{{ answer.points }} punten</span></div>
            </li>
        </transition-group>
        <span @click="(current > 0) ? current-- : current = current" class="slideshow-button prev"></span>
        <span @click="(current < answers.length - 1) ? current++ : current = current" class="slideshow-button next"></span>
    </v-touch>
</template>

<script>
import './AnswersSlideshow.scss'
export default {
    name: 'answers-slideshow',
    data: () => ({
        current: 0,
        direction: null
    }),
    props: {
        mod: {
            type: Number,
            default: 0
        }
    },
    computed: {
        answers: {
            get () {
                return this.$store.state.game.episodes[this.$store.state.game.episode - this.mod].answers
            }
        }
    },
    methods: {
        leave (el, done) {
            TweenMax.fromTo(el, 0.3, { x: (this.direction) ? 200 : -200, opacity: 1 }, {x: (this.direction) ? -200 : 200, opacity: 0, onComplete: done, force3D: true}, 0.2)
        },
        enter (el, done) {
            TweenMax.fromTo(el, 0.3, {x: (this.direction) ? 200 : -200, opacity: 0}, {x: 0, display: 'block', opacity: 1, onComplete: done, force3D: true}, 0.2)
        }
    },
    watch: {
        'current': function (newVal, oldVal) {
            this.direction = (newVal > oldVal)
        }
    }
}
</script>




// WEBPACK FOOTER //
// AnswersSlideshow.vue?1c3f6010